export * from "./key";



//////////////////
// WEBPACK FOOTER
// ./node_modules/firebase-key/dist/index.js
// module id = 2182
// module chunks = 0